import { ArrowLeftOutlined, ArrowRightOutlined } from '@icon';
import { Calendar } from '@rehookify/datepicker';
import React from 'react';
import IconButton from '../../../../icon-button';
import CalendarHeader from '../../../components/calendar-header';
import DatePanel from '../../../components/date-panel';
import DateTitle from '../../../components/date-title';
import { TPropsGetters } from '../../../date-time.types';
import { TPanelMode } from '../../../date-time.utils';

interface RangePickerDaysProps {
  weekDays: string[];
  calendars: Calendar[];
  propGetters: TPropsGetters;
  setPanelMode: React.Dispatch<React.SetStateAction<TPanelMode>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RangePickerDays: React.FunctionComponent<RangePickerDaysProps> = ({
  calendars,
  weekDays,
  propGetters,
  setPanelMode,
  //   setOpen,
  //   shouldClose,
}) => {
  return (
    <>
      <div>
        <CalendarHeader
          left={
            <IconButton
              Icon={ArrowLeftOutlined}
              size="small"
              variant="ghost-tertiary"
              {...propGetters.previousMonthButton()}
            />
          }
        >
          <DateTitle
            month={calendars[1].month}
            year={calendars[1].year}
            onMonthClick={() => setPanelMode('month')}
            onYearClick={() => setPanelMode('year')}
          />
        </CalendarHeader>
        <DatePanel
          dayButton={propGetters.dayButton}
          days={calendars[1].days}
          weekDays={weekDays}
          weekDaysPrefix={calendars[1].month}
        />
      </div>
      <div>
        <CalendarHeader
          right={
            <IconButton
              Icon={ArrowRightOutlined}
              size="small"
              variant="ghost-tertiary"
              {...propGetters.nextMonthButton()}
            />
          }
        >
          <DateTitle
            month={calendars[0].month}
            year={calendars[0].year}
            onMonthClick={() => setPanelMode('month')}
            onYearClick={() => setPanelMode('year')}
          />
        </CalendarHeader>
        <DatePanel
          dayButton={propGetters.dayButton}
          days={calendars[0].days}
          weekDays={weekDays}
          weekDaysPrefix={calendars[0].month}
        />
      </div>
    </>
  );
};

export default RangePickerDays;
